import TaskGroup from '../components/tasks/task-group.tsx';
import { ICard } from '../components/tasks/task-card.tsx';
import { useMemo } from 'react';
import { useSuspenseQuery } from '@apollo/client';
import { GET_MY_COURSES } from '../apollo/user-assignments.ts';
import { orderBy } from 'lodash';

const getCardCreatedAtTime = (card: ICard) =>
  card.createdAt ? new Date(card.createdAt).getTime() : 0;

const setMostRecentCourseCard = (
  coursesMap: Map<number, ICard>,
  card: ICard,
) => {
  const existingCard = coursesMap.get(card.id);

  if (
    !existingCard ||
    getCardCreatedAtTime(card) > getCardCreatedAtTime(existingCard)
  ) {
    coursesMap.set(card.id, card);
  }
};

const Courses = () => {
  const { data } = useSuspenseQuery(GET_MY_COURSES, { errorPolicy: 'all' });
  const courses = data?.user.me.members;
  const purchases = data?.user.me.purchases;

  const coursesCards: ICard[] = useMemo(() => {
    const coursesMap = new Map<number, ICard>();

    courses?.forEach((el) => {
      if (el.course) {
        setMostRecentCourseCard(coursesMap, {
          id: el.course.id,
          title: el.course.name,
          createdAt: el.createdAt,
          description: el.course.description || '',
          type: 'Course',
        });
      }
    });

    purchases?.forEach((el) => {
      if (el.course) {
        setMostRecentCourseCard(coursesMap, {
          id: el.course.id,
          title: el.course.name,
          createdAt: el.createdAt,
          description: el.course.description || '',
          type: 'Course',
          purchase: true,
        });
      }
    });

    return orderBy(
      Array.from(coursesMap.values()),
      getCardCreatedAtTime,
      'desc',
    );
  }, [courses, purchases]);

  return (
    <section>
      {!coursesCards.length ? (
        <p className={'mt-20 text-center text-lg font-medium text-dark-blue'}>
          You don't have any courses
        </p>
      ) : (
        <div>
          <h1>
            Courses
            <span className={'amount-indicator'}>{coursesCards.length}</span>
          </h1>
          <TaskGroup cards={coursesCards} />
        </div>
      )}
    </section>
  );
};
export default Courses;
